import { Grid, MenuItem, TextField, Typography } from "@mui/material";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SeverityTypesEnum } from "../types";
import { Option } from "../../../main/components/SelectInput";

import { useContext, useState } from "react";

import { MainContext } from "../../../main/context/MainContextProvider";
import { useNavigate } from "react-router-dom";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import ConfirmationDialog from "./ConfirmationDialog";
import BaseButton from "../../../main/components/BaseButton";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import { useForm } from "react-hook-form";
import { postCriarMatrizAlarme } from "../../../services/api/routes/alarms";

const alarmSchema = yup.object().shape({
  name: yup.string().nullable().required("Nome do alarme é obrigatório"),
  codigo: yup.string().nullable().required("Código do alarme é obrigatório"),
  type: yup.string().nullable(),
  specializedTechnical: yup.string().nullable(),
  technicalAssistance: yup.string().nullable(),
  provider: yup.string().nullable(),
  dealership: yup.string().nullable(),
  severity: yup.number().required("Severidade do alarme é obrigatório"),
});

const schema = yup.object().shape({
  collaborators: yup.array().of(alarmSchema),
});
const getSeverityByType: Record<string, string> = {
  [SeverityTypesEnum.bland.toString()]: "Brando",
  [SeverityTypesEnum.medium.toString()]: "Médio",
  [SeverityTypesEnum.severe.toString()]: "Severo",
};

export default function AlarmFormRegister() {
  // const { canEditLayout, setCanEditLayout } = useContext(DashboardContext);
  const { handleSubmit } = useForm({
    resolver: yupResolver(schema),
  });

  const severityOptions: Option[] = Object.keys(getSeverityByType).map(
    (key) => ({
      value: key,
      label: getSeverityByType[key],
    })
  );
  const [isCancelConfirmationOpen, setCancelConfirmationOpen] = useState(false);
  const [isSaveConfirmationOpen, setSaveConfirmationOpen] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;

  const navigate = useNavigate();
  const [data, setData] = useState<{
    name?: string | null | undefined;
    codigo?: string | null | undefined;
    type?: string | null | undefined;
    message?: string | null | undefined;
    causes?: string | null | undefined;
    solutions?: string | null | undefined;
    severity?: number;
  }>({
    name: null,
    codigo: null,
    type: null,
    message: null,
    causes: null,
    solutions: null,
    severity: undefined,
  });

  const handleCancelClick = () => {
    setCancelConfirmationOpen(true);
  };

  const handleSaveClick = () => {
    setSaveConfirmationOpen(true);
  };

  const onClose = () => {
    navigate("/alarm/matriz");
  };

  const handleSave = async () => {
    const severity = data.severity || 0;
    // const severityString = severity.toString();
    console.log(data);
    const postData = {
      code: data.codigo || "",
      name: data.name || "",
      type: data.type || "",
      severity: severity ? severity : undefined,
      message: data.message || "",
      causes: data.causes || "",
      solutions: data.solutions || "",
    };

    await postCriarMatrizAlarme(
      postData.code,
      postData.name,
      postData.type,
      postData.severity ? postData.severity : 0,
      postData.message,
      postData.causes,
      postData.solutions
    );
  };

  return (
    <>
      <Grid
        container
        component={"form"}
        sx={{
          width: "95%",
          height: "30%",
          // justifyContent: "center",
          alignItems: "center",
          textAlign: { xs: "center", md: "left" },
          // marginTop: "-600px",
        }}
        onSubmit={handleSubmit(handleSave)}
      >
        <Grid
          container
          xs={12}
          display={"flex"}
          sx={{
            marginTop: "60px",
            fontSize: {
              xs: "18px",
              sm: "24px",
            },
          }}
        >
          <Typography variant="h6">Adicionar Matriz de Alarme</Typography>
        </Grid>

        <Grid
          container
          xs={12}
          display={"flex"}
          sx={{ marginTop: "60px", marginBottom: "20px" }}
        >
          <Grid item xs={12} textAlign={"start"}>
            <Typography
              variant="h6"
              sx={{
                borderBottom: "1px solid #ccc",
                paddingBottom: 1,
                marginBottom: "15px",
              }}
            >
              Dados do Alarme
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
              label="Nome"
              size="small"
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              value={data.codigo}
              onChange={(e) => setData({ ...data, codigo: e.target.value })}
              label="Código"
              size="small"
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              value={data.type}
              onChange={(e) => setData({ ...data, type: e.target.value })}
              label="Tipo"
              size="small"
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <TextField
              size="small"
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  borderRadius: "4px",
                },
              }}
              inputProps={{
                style: {
                  fontSize: 16,
                },
              }}
              select
              label="Severidade"
              value={data.severity}
              onChange={(e) =>
                setData({
                  ...data,
                  severity: e.target.value ? Number(e.target.value) : undefined,
                })
              }
            >
              <MenuItem value={undefined}>Selecione</MenuItem>
              {severityOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        <Grid item xs={12} textAlign={"start"} marginTop={"60px"}>
          <Typography
            variant="h6"
            sx={{
              borderBottom: "1px solid #ccc",
              paddingBottom: 1,
              marginBottom: "15px",
            }}
          >
            Detalhes Específicos da Matriz de Alarme
          </Typography>
        </Grid>
        <Grid xs={12} item>
          <TextField
            id="outlined-multiline-static"
            label="Mensagem"
            multiline
            rows={4}
            value={data.message}
            onChange={(e) => setData({ ...data, message: e.target.value })}
            fullWidth
            sx={{ marginTop: 3, width: "100%" }}
          />
          <TextField
            id="outlined-multiline-static"
            label="Possíveis Causas"
            multiline
            rows={4}
            value={data.causes}
            onChange={(e) => setData({ ...data, causes: e.target.value })}
            fullWidth
            sx={{ marginTop: 3, width: "100%" }}
          />
          <TextField
            id="outlined-multiline-static"
            label="Possíveis Soluções"
            multiline
            rows={4}
            value={data.solutions}
            onChange={(e) => setData({ ...data, solutions: e.target.value })}
            fullWidth
            sx={{ marginTop: 3, width: "100%" }}
          />
        </Grid>
        <Grid
          container
          justifyContent="space-between"
          sx={{ marginTop: "20px" }}
        >
          <Grid item>
            <DangerBaseButton
              onClick={handleCancelClick}
              title="Cancelar"
              sx={{ height: "38px", width: "145px" }}
            />
          </Grid>
          <Grid item>
            <BaseButton
              onClick={handleSaveClick}
              sx={{
                height: "38px",
                width: "145px",
                backGroundColor: primary,
                borderColor: primary,
                "& .MuiTypography-root": {
                  color: primary,
                },
                "&:hover": {
                  borderColor: primary,
                  backgroundColor: primary,
                  color: primary,
                  "& .MuiTypography-root": {
                    color: "#FFFFFF",
                  },
                },
              }}
              title="Salvar"
            />
          </Grid>
        </Grid>
      </Grid>

      <ConfirmationDialog
        open={isCancelConfirmationOpen}
        title="Descartar cadastro"
        message="Deseja descartar e cancelar o cadastro da matriz de alarme?"
        onConfirm={onClose}
        onCancel={() => setCancelConfirmationOpen(false)}
        onClose={() => setCancelConfirmationOpen(false)}
      />

      <ConfirmationModal
        open={isSaveConfirmationOpen}
        setOpen={() => setSaveConfirmationOpen(false)}
        title="Cadastrar Matriz de Alarme"
        contentText="Deseja confirmar o cadastro desta matriz de alarme?"
        onConfirm={() => handleSave()}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />

      <ActionAlert
        message="A matriz de alarme foi cadastrada com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={() => setOpenSuccessModal(false)}
        onClose={() => navigate("/alarm/matriz")}
      />
      <ActionAlert
        message="Ocorreu um erro ao cadastrar a matriz de alarme! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        onClose={() => setSaveConfirmationOpen(false)}
      />
    </>
  );
}
